var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.134 3.19a3.75 3.75 0 0 0-4.269 0l-6.75 4.674A3.75 3.75 0 0 0 1.5 10.947v7.803a3.75 3.75 0 0 0 3.75 3.75h13.5a3.75 3.75 0 0 0 3.75-3.75v-7.803a3.75 3.75 0 0 0-1.616-3.083l-6.75-4.673ZM10.72 4.425a2.25 2.25 0 0 1 2.562 0l6.75 4.673c.063.044.123.09.181.14l-7.297 5.613c-.053.041-.108.078-.165.11V9l1.8 1.35a.75.75 0 1 0 .9-1.2l-3-2.25a.75.75 0 0 0-.9 0l-3 2.25a.75.75 0 0 0 .9 1.2L11.25 9v5.96a1.528 1.528 0 0 1-.165-.11L3.788 9.237a2.25 2.25 0 0 1 .181-.14l6.75-4.673ZM3.035 10.55a2.25 2.25 0 0 0-.035.397v7.803A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75v-7.803c0-.134-.012-.267-.035-.397l-7.136 5.49a3 3 0 0 1-3.658 0l-7.136-5.49Z"
  })));
};

export default SvgFeedback;